import { likesApi as api } from './likesApi';
export const addTagTypes = ['Likes'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getLikes: build.query<GetLikesApiResponse, GetLikesApiArg>({
        query: queryArg => ({
          url: `/likes`,
          params: { assetId: queryArg.assetId }
        }),
        providesTags: ['Likes']
      }),
      addLikes: build.mutation<AddLikesApiResponse, AddLikesApiArg>({
        query: queryArg => ({
          url: `/likes`,
          method: 'POST',
          body: queryArg.createLikes
        }),
        invalidatesTags: ['Likes']
      }),
      getCounts: build.query<GetCountsApiResponse, GetCountsApiArg>({
        query: queryArg => ({
          url: `/likes/counts`,
          params: { assetId: queryArg.assetId }
        }),
        providesTags: ['Likes']
      }),
      deleteLikes: build.mutation<DeleteLikesApiResponse, DeleteLikesApiArg>({
        query: queryArg => ({
          url: `/likes/${queryArg.id}`,
          method: 'DELETE',
          params: { userId: queryArg.userId, assetId: queryArg.assetId }
        }),
        invalidatesTags: ['Likes']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetLikesApiResponse = /** status 200 Likes found. */ {
  ok?: boolean;
  data?: LikesCount;
  message?: string;
};
export type GetLikesApiArg = {
  /** assetId */
  assetId?: string;
};
export type AddLikesApiResponse =
  /** status 201 Likes has been created successfully. */ {
    ok?: boolean;
    data?: Likes;
    message?: string;
  };
export type AddLikesApiArg = {
  /** Likes that needs to be added to the application */
  createLikes: CreateLikes;
};
export type GetCountsApiResponse =
  /** status 200 Counts retrieved successfully. */ {
    ok?: boolean;
    data?: AssetCounts;
    message?: string;
  };
export type GetCountsApiArg = {
  /** Asset ID to get counts for */
  assetId: string;
};
export type DeleteLikesApiResponse =
  /** status 200 The Likes's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteLikesApiArg = {
  id: string;
  /** ID of the user who owns the like */
  userId: string;
  /** ID of the asset associated with the like */
  assetId: string;
};
export type LikesCount = {
  count?: number;
  userIds: {
    userId?: string;
  }[];
};
export type Likes = {
  id: string;
  assetId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
};
export type CreateLikes = {
  assetId: string;
  userId: string;
};
export type AssetCounts = {
  likes?: number;
  comments?: number;
  diary?: number;
};
export const {
  useGetLikesQuery,
  useAddLikesMutation,
  useGetCountsQuery,
  useDeleteLikesMutation
} = injectedRtkApi;
